import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Lodinging from "../components_root/loading.jsx";
import Loadingimg from '../components_root/loadingimg.jsx';
import { googleLogout, checkUserAuth } from '../firebase.js';
import { MdMoreVert } from "react-icons/md";
//page links   
import './softwear.css';
import ShareButton from '../components_root/ShareButton.jsx';
import Header from '../body_root/header.jsx';
import Footers from '../body_root/footer.jsx';
import Navbar from '../body_root/Navbar.jsx';
import Select_yes_no from '../components_root/select_yes_no.jsx';
import { Save_companies } from './save_companies.js';
import { MdCall, MdCode,MdBusinessCenter, MdEditDocument, MdFace, MdKey, MdKeyboard, MdLocationCity, MdOutlinePhoneAndroid, MdPhoneAndroid, MdPictureAsPdf, MdQrCode } from "react-icons/md";
 
export default function Software() {
  const navigate = useNavigate();
  const [stockscompanies, setStockscompanies] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [communitydata, setCommunitydata] = useState([]);
  useEffect(() => {
    setLoading(true);

    const unsubscribe = onSnapshot(
      collection(db, "companies_price"),
      (snapshot) => {
        const dataList = snapshot.docs.map(doc => ({
          uid: doc.id,
          ...doc.data()
        }));
        setStockscompanies(dataList);
        setLoading(false);
      },
      (error) => {
        console.error("❌ Error in get_companies:", error);
        setLoading(false);
      }
    );

    // Cleanup when component unmounts
    // return () => unsubscribe();
  }, []);
  const get_companie = async () => {
    const res = await Save_companies();
    if (res.length > 0) {
      alert(`Found ${res.length} companies`);
    } else {
      alert("No companies found or request failed.");
    }
  };
  const get_community = async () => {
    try {
      const masterQuery = query(
        collection(db, "community"),
        where("status", "==", true),
        orderBy("date_time", "desc"),
        limit(6)
      );
      setIsLoading(true);
      const masterSnap = await getDocs(masterQuery);
      const dataList = masterSnap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));

      setCommunitydata(dataList);
      setIsLoading(false);

    } catch (error) {
      console.error("❌ Error in get_trade_master:", error);
    }
  };
  useEffect(() => {
    get_community();
  }, []);
  return (
    <div>
      <Header />
      <Helmet>
        {/* Title */}
        <title>Viabig – AI, IT Solutions, Cloud, Productivity, & Software Development</title>

        {/* SEO Meta */}
        <meta
          name="description"
          content="Viabig is a leading IT company offering AI solutions, AI agent development, software development, web & mobile apps, digital marketing, cloud services, and IT consultancy."
        />
        <meta
          name="keywords"
          content="Viabig, AI development, AI agent integration, IT company, software development, web development, app development, digital marketing, cloud services, technology solutions"
        />
        <meta name="author" content="Viabig Team" />
        <meta name="date" content={new Date().toISOString()} />
        {/* Open Graph */}
        <meta
          property="og:title"
          content="Viabig – AI, IT Solutions, Cloud, Productivity, & Software Development"
        />
        <meta
          property="og:description"
          content="Viabig provides innovative AI solutions, Cloud, Productivity, AI agent development & integration, software, web & mobile apps, digital marketing, and cloud services to empower your business."
        />
        <meta property="og:image" content="https://viabig.com/logo.png" />
        <meta property="og:url" content="https://viabig.com" />
        <meta property="og:type" content="website" />

        <meta property="og:updated_time" content={new Date().toISOString()} />

        <meta
          name="twitter:description"
          content="Viabig offers AI solutions,Cloud, Productivity, AI agent development & integration, software development, web & mobile apps, digital marketing, and cloud management."
        />
        <meta name="twitter:image" content="https://viabig.com/og-image.png" />
      </Helmet>

      <div className='container_roots'>
        <div className="soft_banner_body">
          {/* <img src={software} className="background_video" /> */}
          {/* <source src={propertyVideo} type="video/mp4" /> */}
          {/* Your browser does not support HTML5 video. */}



          <div className="set-loc-div">
            <div className="banner-cont-body">
              {/* <div className="banner-Headline text-shadow">
                Viabig – AI & IT Solutions for the Future
              </div>
              <div className="banner-Tagline text-shadow">
                Empowering businesses with cutting-edge AI solutions, software development, web & mobile apps, digital marketing, and Cloud Productivity services.
              </div> */}
              <br />
              <br />

              <div className="post-container">
                <div className="ui-items button-ui p-33 shadow center">
                  <MdBusinessCenter className="icon" />
                  Explore Our Services
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className='container_size'>
          <div className='post_div'>   

                        <div className='ui-grid-100'>
                                   <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdCall className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/phonebook')} >Phonebook</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                   <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdPictureAsPdf className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/image-to-pdf')} >Image to  pdf</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                        <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdFace className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/favicon-generator')} >Favicon  </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                       <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdEditDocument className="icon" /></td>
                                        <td>
                                          <div  onClick={() => navigate('/word-counter')} >Word counter</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdKeyboard className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/typing-master')} >Typing master</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                           
                        </div>
                    </div>

 
        </div>
        <br />
        <div className='container_size'>


          <div class="items-back p-2  ">
            <div className="text-h1 bold">About Viabig</div>
            <p className="text-h2">Viabig is a leading IT company specializing in AI solutions, AI agent development & integration, software development, and IT consultancy. Our mission is to help businesses innovate, automate, and scale using the latest technology.</p>
          </div>

          <br />
          {/* offers-loc-div */}
          <div className="offers-loc-div">
            <div className="ui-grid">
              <div className="ui-items items-back p-2 hover border">
                <div className="text-h1 fw-bold">AI Solutions</div>
                <div className="text-h2">Develop intelligent AI systems, predictive models, and AI agent integrations tailored for your business needs.</div>
              </div>
              <div className="ui-items items-back p-2 hover border">
                <div className="text-h1 fw-bold">AI Agent Development & Integration</div>
                <div className="text-h2">We create AI agents that automate tasks, analyze data, and provide actionable insights for smarter business decisions.</div>
              </div>
              <div className="ui-items items-back p-2 hover border">
                <div className="text-h1 fw-bold">Software Development</div>
                <div className="text-h2">Custom enterprise software, CRM, ERP, and automation tools designed to optimize business workflows.</div>
              </div>
              <div className="ui-items items-back p-2 hover border">
                <div className="text-h1 fw-bold">Web Development</div>
                <div className="text-h2">Responsive, SEO-friendly websites that deliver seamless user experiences across devices.</div>
              </div>
              <div className="ui-items items-back p-2 hover border">
                <div className="text-h1 fw-bold">Mobile App Development</div>
                <div className="text-h2">iOS, Android, and cross-platform mobile applications to engage your customers anywhere.</div>
              </div>
              <div className="ui-items items-back p-2 hover border">
                <div className="text-h1 fw-bold">Cloud Productivity Solutions</div>
                <div className="text-h2">Cloud hosting, migration, and productivity solutions that ensure scalability, collaboration, and security.</div>
              </div>
              <div className="ui-items items-back p-2 hover border ">
                <div className="text-h1 fw-bold">Digital Marketing</div>
                <div className="text-h2">SEO, SEM, social media marketing, and branding services to boost your online presence.</div>
              </div>
            </div>
          </div>


          {/* <div className='container_size'>
      
          <div>
            {loading ? (
              <Lodinging />
            ) : stockscompanies.length === 0 ? (
              <p>companies update</p>
            ) : (
              <div className="ui-grid">
                {stockscompanies.map((row, i) => (
                  <div
                    key={i}
                    className="ui-items items-back border"
                    style={{ padding: "10px 10px" }}
                  >
                    <table>
                      <tr> <td className="font-header bold">{row.symbol}</td>
                        <td width={130}>{<div className="font-details">
                          {row.date_time.toDate().toLocaleDateString()}{" "}
                          {row.date_time.toDate().toLocaleTimeString()}
                        </div>}</td>
                      </tr>
                    </table>
                    <table >
                      <tr><td width={40}>Open</td><td>Change</td><td>Volume</td><td>High</td><td>Low</td></tr>
                      <tr><td  >{row.ohlc.open}</td> <td
                        className={
                          row.netChange > 0
                            ? 'status-ui green-back bold'
                            : row.netChange < 0
                              ? 'status-ui red-back bold'
                              : ''
                        }
                      >
                        {row.netChange}
                      </td><td >{row.volume}</td><td className='green'>{row.ohlc.high}</td><td className='red'>{row.ohlc.low}</td>

                      </tr>

                    </table>


                  </div>
                ))}
              </div>
            )}
          </div>

        </div> */}
        </div>
        <br />   <br />
        <div className='container_size'>
            <table>
              <tr>
                <td>
                  <div className='text-h1 bold p-2 '>Community updates</div>
                </td>
                <td width={30} >
                <MdMoreVert class='icon cursor' onClick={() => navigate("/community")} />
                
                </td>
              </tr>
            </table> 
    
            {isLoading ? (
              <Lodinging />
            ) : communitydata.length === 0 ? (
              <p></p>
            ) : (
              <div className="ui-grid">
                {communitydata
                  .filter(row => row.status_confirmed === false || row.status_confirmed === undefined)
                  .map((row, i) => (
                    <div
                      key={i}
                      className="ui-items background-ui-active cursor" onClick={() => navigate("/community?id=" + row.uid)}
                    >
                      <table>
                        <tbody>
                          <tr>
                            <td  >{row.title}</td>
                          </tr>
                          <tr>
                            <td className="text-3 bold fcap" >{row.categories}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ))}
              </div>
            )}
 
        </div>
      </div>
      <Footers />
      <Navbar />
    </div>
  );
}
